var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-inner"},[_c('AppMain'),_c('Footbar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }